export const SHIPPING_ENDPOINTS = {
  LIST: '/customer/shipping/',
  CREATE: '/customer/shipping/',
  GET: (slug: string) => `/customer/shipping/${slug}/`,
  UPDATE: (slug: string) => `/customer/shipping/${slug}/`,
  DELETE: (slug: string) => `/customer/shipping/${slug}/`,
  SET_DEFAULT: (slug: string) => `/customer/shipping/${slug}/default/`,
} as const
